module.exports = __webpack_public_path__ + "img/Liputan-Image-4.0989083a.png";